import React from 'react';
import { createRoot } from 'react-dom/client';
import './assets/scss/index.scss';
import {BrowserRouter} from "react-router-dom";
import {ConfigProvider} from "antd";
import ru_RU from 'antd/es/locale/ru_RU';
import App from './App';
import {store} from "./store";
import {Provider} from "react-redux";
import "./i18n/i18n";

const container: any = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
          }}>
            <ConfigProvider locale={ru_RU}>
                <App/>
            </ConfigProvider>
        </BrowserRouter>
    </Provider>
);
